import * as Scrivito from "scrivito";

const NewsCategoryConfigWidget = Scrivito.provideWidgetClass(
  "NewsCategoryConfigWidget",
  {
    attributes: {
      body: ["widgetlist", { only: ["LocalizedKeyWidget"] }],
    },
    onlyInside: "GlobalConfigPage",
  }
);

export default NewsCategoryConfigWidget;
